// Detects whether an article needs the YMYL medical disclaimer.
export const isPeptideCategory = (article) => {
  if (!article) return false;
  const cat = (article.category || '').toLowerCase();
  const title = (article.title || '').toLowerCase();
  const tags = (article.tags || []).map((t) => (t || '').toLowerCase());
  return ['peptides', 'peptide-therapy', 'biohacking', 'longevity', 'supplements'].includes(cat)
    || tags.some((t) => ['peptide', 'bpc-157', 'aod-9604', 'dihexa', 'ghk-cu', 'mk-677', 'retatrutide', 'tb-500', 'mots-c', 'kpv', 'semaglutide'].includes(t))
    || /peptide|bpc.?157|aod.?9604|dihexa|ghk.?cu|mk.?677|retatrutide|tb.?500|semaglutide/i.test(title);
};

export const isHyroxArticle = (article) => {
  if (!article) return false;
  if (article.category === 'HYROX') return true;
  const tags = (article.tags || []).map((t) => (t || '').toLowerCase());
  return tags.some((t) => ['hyrox', 'functional fitness', 'endurance', 'race training'].includes(t));
};

export const articleUrlFor = (slug) => `https://ninjathlete.com/blogs/article/${slug}`;
